import React from "react";
import { PopupsSection } from "../Actions/PopupsData";
import { VersionData } from "./ApiVersionProvider";

interface PopupsDispatcher {
    type?: "SUCCESS" | "CLOSE" | "ERROR",
    payload?: PopupsSectionPayload
}

interface PopupsSectionPayload {
    data?: PopupsSection,
    loading?: boolean,
    errorMessage?: string,
    isLoaded?: boolean
}

// - Actions
export async function setPopupsSectionData( data: PopupsSection, dispatcher: React.Dispatch<PopupsDispatcher>) {
    localStorage.setItem('popupsSection', JSON.stringify(data));

    if(data.isClosed === undefined) {
        data.isClosed = false;
    }

    if(data.popups === undefined || data.popups.length === 0){
        data.isClosed = true;
    }

    dispatcher({ type: 'SUCCESS', payload: { data } });
}

export async function cleseSectionData(  dispatcher: React.Dispatch<PopupsDispatcher>) {
    dispatcher({ type: 'CLOSE'});
}

const popupsSectionInitialState: PopupsSectionPayload = {
    data: undefined,
    loading: false,
    errorMessage: '',
    isLoaded: false
}

const popupsSectionData = localStorage.getItem('popupsSection');
if (popupsSectionData) {
    let localVersionData = localStorage.getItem('versions');
    if ( localVersionData) {
        const localData : VersionData = JSON.parse(localVersionData);
        if(localData.versions && localData.versions.popups ){
            const popupssSectionDataDataObj: PopupsSection = JSON.parse(popupsSectionData);
            if (popupssSectionDataDataObj.version === localData.versions.popups) {
                popupsSectionInitialState.data = popupssSectionDataDataObj;
                popupsSectionInitialState.isLoaded = true;
            }
        }
    }
}

let popupsSectionReducer = (state: PopupsSectionPayload, action: PopupsDispatcher): PopupsSectionPayload => {
    const currentState = {...state};
    switch (action.type) {
        case 'SUCCESS':
            return { ...state, loading: false, data: action.payload?.data, isLoaded: true };
        case 'CLOSE':
            if(currentState.data){
                currentState.data.isClosed = true;
            }
            return currentState;
        case 'ERROR':
            return { ...state, loading: false, errorMessage: action.payload?.errorMessage };
        default:
            return state;
    }
}

const PopupsSectionStateContext = React.createContext<PopupsSectionPayload>({})
const PopupsSectionDispatchContext = React.createContext< React.Dispatch<PopupsDispatcher> >(() => null)

export function usePopupsSectionState(){
    const context = React.useContext(PopupsSectionStateContext)
    if (context === undefined) {
        throw new Error("useAppsState must be used within a DiazarSuiteProvider");
    }

    return context;
}

export function usePopupsSectionDispatch(){
    const context = React.useContext(PopupsSectionDispatchContext)
    if (context === undefined) {
        throw new Error("useAppsDispatch must be used within a DiazarSuiteProvider");
    }

    return context;
}


interface ViewProps {
    children?: React.ReactNode | undefined
}

export const PopupsSectionProvider: React.FunctionComponent<ViewProps> = (props) => {
    const { children } = props;
    const [state, dispatch] = React.useReducer(popupsSectionReducer, popupsSectionInitialState);

    return (
        <PopupsSectionStateContext.Provider value={state}>
            <PopupsSectionDispatchContext.Provider value={dispatch}>
                { children }
            </PopupsSectionDispatchContext.Provider>
        </PopupsSectionStateContext.Provider>
    )
}